import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'

interface SystemSettings {
  maintenance_mode: boolean
  meta_api_down?: boolean
  meta_api_down_posting?: boolean
  meta_api_down_broadcast?: boolean
}

export function useSystemSettings() {
  return useQuery<SystemSettings>({
    queryKey: ['system-settings'],
    queryFn: () => api.get('/system-settings'),
    staleTime: 60_000,
  })
}
